import FulfillmentWorkbench from './FulfillmentWorkbench';

export default function OrdersFulfillment() {
  return <FulfillmentWorkbench />;
}
